var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "mx-auto", attrs: { elevation: "0", "max-width": "800" } },
    [
      _c(
        "div",
        { staticClass: "sticky-header" },
        [
          _c("v-card-title", { staticClass: "headline font-weight-light" }, [
            _vm._v(_vm._s(_vm.location.details.name))
          ]),
          _c("v-card-subtitle", { staticClass: "pb-0 font-weight-medium" }, [
            _vm._v(
              _vm._s(_vm.location.rooms.length) +
                " " +
                _vm._s(_vm.$t("reserve.roomsAvailable"))
            )
          ])
        ],
        1
      ),
      _c("co-room-list", { attrs: { rooms: _vm.location.rooms } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }